import {Component, Inject, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {TranslocoPipe} from '@jsverse/transloco';

/**
 * The portal's settings, opened from the app bar and anchored to the bottom of the screen. A dialog
 * rather than Material's bottom sheet, whose size and padding can only be changed by overriding its
 * internal CSS.
 */
@Component({
  selector: 'app-waitlist-settings',
  imports: [MatIconModule, MatDialogClose, MatSlideToggleModule, TranslocoPipe],
  templateUrl: './waitlist-settings.dialog.html',
  styleUrl: './waitlist-settings.dialog.scss'
})
export class WaitlistSettingsDialog {
  dialogRef = inject(MatDialogRef<WaitlistSettingsDialog>);

  notificationsEnabled: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { notificationsEnabled: boolean }) {
    this.notificationsEnabled = data.notificationsEnabled;
  }

  // closes with the new value only when it changed, so opening and closing sends nothing
  onToggle(enabled: boolean) {
    this.notificationsEnabled = enabled;
    this.dialogRef.close(enabled === this.data.notificationsEnabled ? undefined : enabled);
  }
}
